
export const translations = {
  es: {
    seo: {
      title: "AxiomityFX | Software de Trading Automatizado Forex (Expert Advisor)",
      description: "AxiomityFX es el Expert Advisor (EA) de última generación para MT4. Trading 100% automatizado en EURUSD y AUDCAD con más de 16 años de historial."
    },
    nav: {
      advantages: "Ventajas",
      results: "Resultados",
      licenses: "Licencias",
      faqs: "FAQs",
      contact: "Contacto"
    },
    hero: {
      description: "Sistema de trading automatizado diseñado para obtener rendimientos cada día con la máxima estabilidad.",
      buy: "Comprar licencia",
      results: "Resultados"
    },
    about: {
      title: "100% Automatizado",
      features: {
        profit: { label: "BENEFICIO", desc: "Promedio mensual del 5,50%" },
        risk: { label: "RIESGO", desc: "Drawdown máximo del 60% del capital" },
        history: { label: "TRAYECTORIA", desc: "Más de 16 años de beneficios" }
      },
      paragraphs: [
        "AxiomityFX emplea tecnología de última generación para identificar tendencias del mercado y ejecutar operaciones en tiempo real, ofreciendo una operativa totalmente automatizada y de nivel profesional, sin necesidad de intervención manual.",
        "El sistema opera en los pares EUR/USD y AUD/CAD y analiza el mercado mediante un conjunto de indicadores avanzados para determinar su dirección. En función de esta predicción, abre posiciones de compra o venta y establece automáticamente un nivel de take profit.",
        "Si el mercado evoluciona en sentido contrario, AxiomityFX activa un sistema de coberturas progresivas que reajusta dinámicamente el take profit de todo el conjunto de operaciones.",
        "En el momento en que el precio se mueve a favor, el sistema cierra todo el bloque de posiciones asegurando beneficios. Si la tendencia adversa continúa, la estrategia de coberturas sigue actuando hasta alcanzar el objetivo."
      ]
    },
    performance: {
      title: "Resultados Históricos",
      subtitle: "Rendimiento de AxiomityFX desde 2010",
      year: "Año",
      total: "Total Anual",
      expand: "Ver historial completo desde 2010",
      collapse: "Comprimir historial",
      disclaimer: "* Los rendimientos presentados corresponden a test con calidad de modelado del 99,90%. No obstante, los rendimientos pasados no garantizan resultados futuros. El trading en Forex implica un riesgo sustancial. AxiomityLab no gestiona capital de terceros, únicamente provee licencias de software para uso personal bajo responsabilidad del usuario.",
      months: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    },
    pricing: {
      title: "Elige tu licencia",
      subtitle: "Suscripciones diseñadas para adaptarse a tu capital",
      popular: "Más Popular",
      buy: "Comprar licencia",
      period: "anual",
      tiers: {
        starter: {
          name: "LICENCIA STARTER",
          features: [
            'Licencia anual AxiomityFX',
            'Capital mínimo necesario: 5.000€',
            'Operar en el bróker patrocinado (Roboforex)',
            'Permitidos 1 instancia del par EURUSD y 2 instancias del AUDCAD',
            'Soporte técnico en la instalación',
            'Soporte general vía Telegram',
            'Actualizaciones gratuitas'
          ]
        },
        pro: {
          name: "LICENCIA PRO",
          features: [
            'Licencia anual AxiomityFX',
            'Capital mínimo necesario: 10.000€',
            'Operar en el bróker patrocinado (Roboforex)',
            'Permitidos 2 instancias del par EURUSD y 4 instancias del AUDCAD',
            'Soporte técnico en la instalación',
            'Soporte general vía Telegram',
            'Actualizaciones gratuitas'
          ]
        },
        unlimited: {
          name: "LICENCIA UNLIMITED",
          features: [
            'Licencia anual AxiomityFX',
            'Capital mínimo necesario: 10.000€',
            'Operar en cualquier bróker',
            'Permitidos 2 instancias del par EURUSD y 4 instancias del AUDCAD',
            'Soporte técnico en la instalación',
            'Soporte general vía Telegram',
            'Actualizaciones gratuitas'
          ]
        }
      }
    },
    faq: {
      title: "Preguntas Frecuentes",
      subtitle: "Todo lo que necesitas saber antes de empezar con AxiomityFX.",
      items: [
        {
          q: "¿Necesito experiencia previa en trading?",
          a: "No es necesario tener experiencia. AxiomityFX es un sistema 100% automático. Proporcionamos una guía paso a paso para la instalación y configuración inicial."
        },
        {
          q: "¿Necesito dedicarle tiempo?",
          a: "No es necesario dedicarle tiempo. AxiomityFX es un sistema 100% automático. Funcionará 24h y abrirá y cerrará las operaciones por ti. Se recomienda realizar una tarea de supervisión cada cierto tiempo para comprobar que el software está ejecutándose correctamente, pero no es necesario intervenir manualmente."
        },
        {
          q: "¿En qué plataformas funciona AxiomityFX?",
          a: "AxiomityFX está diseñado para MetaTrader 4 (MT4), la plataforma estándar de la industria para el trading algorítmico."
        },
        {
          q: "¿En qué brókers funciona AxiomityFX?",
          a: "AxiomityFX está diseñado y testeado para funcionar en el bróker Roboforex. No obstante dependiendo de tu licencia podrás utilizarlo también en otros brókers."
        },
        {
          q: "¿Cuál es el capital mínimo recomendado?",
          a: "Para operar de forma segura con nuestra gestión de riesgo sugerida, recomendamos empezar con al menos 5.000€ para la licencia STARTER y de 10.000€ para la licencia PRO."
        },
        {
          q: "¿Puedo retiar mi dinero?",
          a: "Usted será dueño de capital, podrá retirar del bróker y detener la operativa cuando quiera."
        },
        {
          q: "¿Qué pasa si mi VPS/PC se desconecta?",
          a: "AxiomityFX tiene implementado un sistema de aviso por Telegram para ser notificados de cualquier desconexión producida. En dicho caso, únicamente tendrá que reconectar el sistema lo antes posible para que la operativa pueda continuar ejecutándose."
        },
        {
          q: "¿Ofrecen soporte técnico?",
          a: "Sí, ofrecemos soporte técnico por Telegram con todos los tipos de licencias"
        }
      ]
    },
    contact: {
      title: "Hablemos en privado",
      span: "privado",
      subtitle: "¿Tienes dudas antes de empezar? Agenda una sesión técnica o contáctanos directamente por nuestras vías oficiales.",
      cardTitle: "Consultoría 1 a 1",
      cardDesc: "Reserva una sesión personalizada. Veremos el software operando en vivo, analizaremos el riesgo y resolveremos todas tus dudas.",
      points: [
        "Análisis de AxiomityFX",
        "Demo en vivo",
        "Análisis Riesgo/Beneficio",
        "Dudas técnicas"
      ],
      cta: "Agendar sesión gratuita",
      noCommitment: "Sin compromiso de compra",
      support: "Soporte 24/5",
      queries: "Consultas"
    },
    footer: {
      legalInfo: "Información Legal",
      copyright: "© 2026 Axiomity Lab - Todas las marcas registradas.",
      disclaimer: "ADVERTENCIA: El trading en mercados financieros implica un alto nivel de riesgo y puede no ser adecuado para todos los inversores. Puede perder la totalidad del capital invertido. Antes de decidir invertir, considere cuidadosamente sus objetivos de inversión y apetito de riesgo.",
      links: {
        terms: "Términos del Servicio",
        disclaimer: "Descargo de Responsabilidad",
        privacy: "Política de Privacidad",
        cookies: "Cookies",
        close: "Cerrar y volver"
      }
    },
    modal: {
      title: "Finalizar Compra",
      product: "Producto",
      total: "Total Anual",
      terms: "Acepto los términos legales y condiciones del servicio.",
      risk: "Autorizo el descargo de responsabilidad y entiendo los riesgos.",
      pay: "Pagar ahora",
      redirecting: "Redirigiendo a Stripe...",
      secure: "Serás redirigido a la pasarela de pago segura de Stripe."
    },
    toast: {
      title: "¡Operación completada!",
      desc: "Tu licencia se está procesando. Revisa tu email para las instrucciones."
    },
    cookie: {
      title: "Privacidad y Cookies",
      desc: "Utilizamos cookies propias y de terceros para mejorar tu experiencia y analizar el tráfico. Puedes aceptar todas las cookies o consultar nuestra política de cookies para más información.",
      accept: "Aceptar Todo",
      necessary: "Solo necesarias"
    }
  },
  en: {
    seo: {
      title: "AxiomityFX | Automated Forex Trading Software (Expert Advisor)",
      description: "AxiomityFX is the next-gen Expert Advisor for MT4. 100% automated trading on EURUSD and AUDCAD with a 16-year verified track record."
    },
    nav: {
      advantages: "Advantages",
      results: "Results",
      licenses: "Licenses",
      faqs: "FAQs",
      contact: "Contact"
    },
    hero: {
      description: "Automated trading system designed to obtain returns every day with maximum stability.",
      buy: "Buy license",
      results: "Performance"
    },
    about: {
      title: "100% Automated",
      features: {
        profit: { label: "PROFIT", desc: "Average monthly return: 5.50%" },
        risk: { label: "RISK", desc: "Maximum historical drawdown: 60%" },
        history: { label: "TRACK RECORD", desc: "Over 16 years of profits" }
      },
      paragraphs: [
        "AxiomityFX uses cutting-edge technology to identify market trends and execute real-time trades, offering a fully automated, professional-level experience without manual intervention.",
        "The system operates on EUR/USD and AUD/CAD pairs, analyzing the market through advanced indicators to determine direction. Based on these predictions, it opens buy/sell positions and sets automatic take profits.",
        "If the market moves against a position, AxiomityFX activates a progressive hedging system that dynamically adjusts the take profit for the entire set of trades.",
        "When the price moves in favor, the system closes the entire block of positions, securing profits. If the adverse trend persists, the hedging strategy continues to act until the objective is reached."
      ]
    },
    performance: {
      title: "Historical Results",
      subtitle: "AxiomityFX Performance since 2010",
      year: "Year",
      total: "Annual Total",
      expand: "View complete history since 2010",
      collapse: "Collapse history",
      disclaimer: "* Results presented correspond to tests with 99.90% modeling quality. However, past performance does not guarantee future results. Forex trading involves substantial risk. AxiomityLab does not manage third-party capital; it only provides software licenses for personal use under user responsibility.",
      months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    },
    pricing: {
      title: "Choose your license",
      subtitle: "Subscriptions designed to adapt to your capital",
      popular: "Most Popular",
      buy: "Buy license",
      period: "yearly",
      tiers: {
        starter: {
          name: "STARTER LICENSE",
          features: [
            'AxiomityFX annual license',
            'Minimum required capital: €5,000',
            'Trade on sponsored broker (Roboforex)',
            'Allowed: 1 instance of EURUSD and 2 of AUDCAD',
            'Technical installation support',
            'General support via Telegram',
            'Free updates'
          ]
        },
        pro: {
          name: "PRO LICENSE",
          features: [
            'AxiomityFX annual license',
            'Minimum required capital: €10,000',
            'Trade on sponsored broker (Roboforex)',
            'Allowed: 2 instances of EURUSD and 4 of AUDCAD',
            'Technical installation support',
            'General support via Telegram',
            'Free updates'
          ]
        },
        unlimited: {
          name: "UNLIMITED LICENSE",
          features: [
            'AxiomityFX annual license',
            'Minimum required capital: €10,000',
            'Trade on any broker',
            'Allowed: 2 instances of EURUSD and 4 of AUDCAD',
            'Technical installation support',
            'General support via Telegram',
            'Free updates'
          ]
        }
      }
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know before starting with AxiomityFX.",
      items: [
        {
          q: "Do I need previous trading experience?",
          a: "No experience is necessary. AxiomityFX is a 100% automated system. We provide a step-by-step guide for initial installation and setup."
        },
        {
          q: "Do I need to dedicate time to it?",
          a: "No time dedication is needed. AxiomityFX is 100% automated. It runs 24/7, opening and closing trades for you. Occasional monitoring is recommended, but manual intervention is not required."
        },
        {
          q: "Which platforms does AxiomityFX work on?",
          a: "AxiomityFX is designed for MetaTrader 4 (MT4), the industry standard for algorithmic trading."
        },
        {
          q: "Which brokers work with AxiomityFX?",
          a: "It is tested for Roboforex. However, depending on your license, you may use it with other brokers."
        },
        {
          q: "What is the recommended minimum capital?",
          a: "To trade safely with our suggested risk management, we recommend starting with at least €5,000 for STARTER and €10,000 for PRO."
        },
        {
          q: "Can I withdraw my money?",
          a: "You own your capital; you can withdraw from the broker and stop the operation whenever you want."
        },
        {
          q: "What if my VPS/PC disconnects?",
          a: "AxiomityFX includes a Telegram notification system for disconnections. In such cases, simply reconnect the system as soon as possible."
        },
        {
          q: "Do you offer technical support?",
          a: "Yes, we offer technical support via Telegram with all license types."
        }
      ]
    },
    contact: {
      title: "Let's talk in ",
      span: "private",
      subtitle: "Have questions before starting? Schedule a technical session or contact us directly through official channels.",
      cardTitle: "1-on-1 Consulting",
      cardDesc: "Book a personalized session. We'll show you the software live, analyze risks, and resolve all your technical doubts.",
      points: [
        "AxiomityFX Analysis",
        "Live Demo",
        "Risk/Reward Analysis",
        "Technical Questions"
      ],
      cta: "Schedule free session",
      noCommitment: "No purchase commitment",
      support: "24/5 Support",
      queries: "Queries"
    },
    footer: {
      legalInfo: "Legal Information",
      copyright: "© 2026 Axiomity Lab - All trademarks registered.",
      disclaimer: "WARNING: Trading in financial markets involves high risk and may not be suitable for all investors. You may lose your entire investment. Carefully consider your goals before investing.",
      links: {
        terms: "Terms of Service",
        disclaimer: "Disclaimer",
        privacy: "Privacy Policy",
        cookies: "Cookies",
        close: "Close and return"
      }
    },
    modal: {
      title: "Checkout",
      product: "Product",
      total: "Annual Total",
      terms: "I accept the legal terms and service conditions.",
      risk: "I authorize the disclaimer and understand the risks.",
      pay: "Pay now",
      redirecting: "Redirecting to Stripe...",
      secure: "You will be redirected to Stripe's secure payment gateway."
    },
    toast: {
      title: "Order Completed!",
      desc: "Your license is being processed. Check your email for instructions."
    },
    cookie: {
      title: "Privacy & Cookies",
      desc: "We use our own and third-party cookies to improve your experience and analyze traffic. You can accept all or check our cookie policy for more information.",
      accept: "Accept All",
      necessary: "Only Necessary"
    }
  }
};
